// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module__font-s-10___N7UPb {
  font-size: 10px !important;
}

.Checkbox-module__font-s-12___TsP7c {
  font-size: 12px !important;
}

.Checkbox-module__font-s-13___Gt0ri {
  font-size: 13px !important;
}

.Checkbox-module__font-s-14___GAdfa {
  font-size: 14px !important;
}

.Checkbox-module__font-s-15___NTuaN {
  font-size: 15px !important;
}

.Checkbox-module__font-s-16___JcXLP {
  font-size: 16px !important;
}

.Checkbox-module__font-s-18___yFv5r {
  font-size: 18px !important;
}

.Checkbox-module__font-s-20___pSW38 {
  font-size: 20px !important;
}

.Checkbox-module__font-s-22___YSdbt {
  font-size: 22px !important;
}

.Checkbox-module__font-s-28___TG50D {
  font-size: 28px !important;
}

.Checkbox-module__font-w-400___L6ktA {
  font-weight: 400 !important;
}

.Checkbox-module__font-w-500___wIHf3 {
  font-weight: 500 !important;
}

.Checkbox-module__font-w-600___pdK_m {
  font-weight: 600 !important;
}

.Checkbox-module__font-w-700___qiLvM {
  font-weight: 700 !important;
}

.Checkbox-module__p-5___n7laJ {
  padding: 5px !important;
}

.Checkbox-module__p-12___s8JxA {
  padding: 12px !important;
}

.Checkbox-module__p-16____puzb {
  padding: 16px !important;
}

.Checkbox-module__p-30___PhhaZ {
  padding: 30px !important;
}

.Checkbox-module__p-b-0___gMMrZ {
  padding-bottom: 0 !important;
}

.Checkbox-module__p-b-5___rKhEh {
  padding-bottom: 5px !important;
}

.Checkbox-module__p-b-10___YClyt {
  padding-bottom: 10px !important;
}

.Checkbox-module__p-b-12___x6TT7 {
  padding-bottom: 12px !important;
}

.Checkbox-module__p-b-16___lZa58 {
  padding-bottom: 16px !important;
}

.Checkbox-module__p-b-18___JKLhP {
  padding-bottom: 18px !important;
}

.Checkbox-module__p-b-20___ZS206 {
  padding-bottom: 20px !important;
}

.Checkbox-module__p-b-25___LkwTg {
  padding-bottom: 25px !important;
}

.Checkbox-module__p-b-30___fHOrH {
  padding-bottom: 30px !important;
}

.Checkbox-module__p-b-50____G59p {
  padding-bottom: 50px !important;
}

.Checkbox-module__p-t-0___c1HY_ {
  padding-top: 0 !important;
}

.Checkbox-module__p-t-12___SwsHy {
  padding-top: 12px !important;
}

.Checkbox-module__p-t-16___H7gja {
  padding-top: 16px !important;
}

.Checkbox-module__p-t-18___zKDLs {
  padding-top: 18px !important;
}

.Checkbox-module__p-t-20___MOIa0 {
  padding-top: 20px !important;
}

.Checkbox-module__p-t-30___NKsk9 {
  padding-top: 30px !important;
}

.Checkbox-module__p-t-40___Beijw {
  padding-top: 40px !important;
}

.Checkbox-module__p-t-50___iwtag {
  padding-top: 50px !important;
}

.Checkbox-module__p-l-20___UrGnF {
  padding-left: 20px !important;
}

.Checkbox-module__p-l-30___SOLuE {
  padding-left: 30px !important;
}

.Checkbox-module__p-l-40___bUmiq {
  padding-left: 40px !important;
}

.Checkbox-module__p-r-16___mSMTT {
  padding-right: 16px !important;
}

.Checkbox-module__p-r-20___I94_B {
  padding-right: 20px !important;
}

.Checkbox-module__p-r-30___kA5Ye {
  padding-right: 30px !important;
}

.Checkbox-module__p-r-50___Y_6Dg {
  padding-right: 50px !important;
}

.Checkbox-module__p-r-60___zGz9P {
  padding-right: 60px !important;
}

.Checkbox-module__m-b-1___xiOze {
  margin-bottom: 1px !important;
}

.Checkbox-module__m-b-2___xMj0q {
  margin-bottom: 2px !important;
}

.Checkbox-module__m-b-6___RTgIn {
  margin-bottom: 6px !important;
}

.Checkbox-module__m-b-8___P9ym7 {
  margin-bottom: 8px !important;
}

.Checkbox-module__m-b-10___mOLap {
  margin-bottom: 10px !important;
}

.Checkbox-module__m-b-14___YbQgs {
  margin-bottom: 14px !important;
}

.Checkbox-module__m-b-16____oOk0 {
  margin-bottom: 16px !important;
}

.Checkbox-module__m-b-20___BuAfo {
  margin-bottom: 20px !important;
}

.Checkbox-module__m-b-22___c0EaL {
  margin-bottom: 22px !important;
}

.Checkbox-module__m-b-24___BXK9b {
  margin-bottom: 24px !important;
}

.Checkbox-module__m-b-30___ZTyTp {
  margin-bottom: 30px !important;
}

.Checkbox-module__m-b-32___HAeQd {
  margin-bottom: 32px !important;
}

.Checkbox-module__m-b-40___CT91L {
  margin-bottom: 40px !important;
}

.Checkbox-module__m-t-2___r4Xzc {
  margin-top: 2px !important;
}

.Checkbox-module__m-t-3___lAvSa {
  margin-top: 3px !important;
}

.Checkbox-module__m-t-4___vSr_W {
  margin-top: 4px !important;
}

.Checkbox-module__m-t-5___RUeUx {
  margin-top: 5px !important;
}

.Checkbox-module__m-t-8___JqYxu {
  margin-top: 8px !important;
}

.Checkbox-module__m-t-10___VlBma {
  margin-top: 10px !important;
}

.Checkbox-module__m-t-15___eIkPy {
  margin-top: 15px !important;
}

.Checkbox-module__m-t-16___nNY1N {
  margin-top: 16px !important;
}

.Checkbox-module__m-t-20___o_YJi {
  margin-top: 20px !important;
}

.Checkbox-module__m-t-22___VKbt5 {
  margin-top: 22px !important;
}

.Checkbox-module__m-t-30___IXMKk {
  margin-top: 30px !important;
}

.Checkbox-module__m-t-32____uVUt {
  margin-top: 32px !important;
}

.Checkbox-module__m-l-auto___fhuVT {
  margin-left: auto !important;
}

.Checkbox-module__m-l-4___YP3Qr {
  margin-left: 4px !important;
}

.Checkbox-module__m-l-5___CJKRV {
  margin-left: 5px !important;
}

.Checkbox-module__m-l-6___Xs0VW {
  margin-left: 6px !important;
}

.Checkbox-module__m-l-8___MaF9J {
  margin-left: 8px !important;
}

.Checkbox-module__m-l-10___Anspo {
  margin-left: 10px !important;
}

.Checkbox-module__m-l-16___UjMzP {
  margin-left: 16px !important;
}

.Checkbox-module__m-l-20___Uxj6H {
  margin-left: 20px !important;
}

.Checkbox-module__m-l-24___A8SEv {
  margin-left: 24px !important;
}

.Checkbox-module__m-l-30___jWu5z {
  margin-left: 30px !important;
}

.Checkbox-module__m-l-35___GECep {
  margin-left: 35px !important;
}

.Checkbox-module__m-l-40___sU2dV {
  margin-left: 40px !important;
}

.Checkbox-module__m-r-8___Q5dBM {
  margin-right: 8px !important;
}

.Checkbox-module__m-r-10___l3yVD {
  margin-right: 10px !important;
}

.Checkbox-module__m-r-16___ScQ_8 {
  margin-right: 16px !important;
}

.Checkbox-module__m-r-20___VWxrl {
  margin-right: 20px !important;
}

.Checkbox-module__m-r-24___zzBqW {
  margin-right: 24px !important;
}

.Checkbox-module__m-r-30___WYGUQ {
  margin-right: 30px !important;
}

.Checkbox-module__m-r-40____iOGv {
  margin-right: 40px !important;
}

.Checkbox-module__border-r-3___DyyaK {
  border-radius: 3px !important;
}

.Checkbox-module__border-r-4___BKsX1 {
  border-radius: 4px !important;
}

.Checkbox-module__border-r-6___XnDGv {
  border-radius: 6px !important;
}

.Checkbox-module__border-r-10___EWdZu {
  border-radius: 10px !important;
}

.Checkbox-module__border-r-12___S6d96 {
  border-radius: 12px !important;
}

.Checkbox-module__border-r-16___g7Fyf {
  border-radius: 16px !important;
}

.Checkbox-module__border-r-50___qiEIy {
  border-radius: 50% !important;
}

.Checkbox-module__primary-border___nEHg5 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Checkbox-module__primary-border-b___KjfZk {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Checkbox-module__primary-border-t___AD9ZZ {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Checkbox-module__primary-border-l___BM6h0 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Checkbox-module__primary-border-r___w8O1Y {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Checkbox-module__secondary-border___p5y5s {
  border: 1px solid #637768;
}

.Checkbox-module__secondary-border-b___kVDRo {
  border-bottom: 1px solid #637768;
}

.Checkbox-module__secondary-border-t___1tX92 {
  border-top: 1px solid #637768;
}

.Checkbox-module__secondary-border-l___CEku5 {
  border-left: 1px solid #637768;
}

.Checkbox-module__secondary-border-r___rFZ6J {
  border-right: 1px solid #637768;
}

.Checkbox-module__gap-0___xjkSD {
  gap: 0 !important;
}

.Checkbox-module__gap-2___GyQ23 {
  gap: 2px !important;
}

.Checkbox-module__gap-4___iZhzm {
  gap: 4px !important;
}

.Checkbox-module__gap-5___XcEMg {
  gap: 5px !important;
}

.Checkbox-module__gap-6___h7RbL {
  gap: 6px !important;
}

.Checkbox-module__gap-8___V11DZ {
  gap: 8px !important;
}

.Checkbox-module__gap-10___hW3TQ {
  gap: 10px !important;
}

.Checkbox-module__gap-12___pnBmH {
  gap: 12px !important;
}

.Checkbox-module__gap-14___OLd4z {
  gap: 14px !important;
}

.Checkbox-module__gap-16___sAR_R {
  gap: 16px !important;
}

.Checkbox-module__gap-18___JVcKa {
  gap: 18px !important;
}

.Checkbox-module__gap-20___EvEHI {
  gap: 20px !important;
}

.Checkbox-module__gap-24___rR5lP {
  gap: 24px !important;
}

.Checkbox-module__gap-26___xbHRn {
  gap: 26px !important;
}

.Checkbox-module__gap-30___MiUl2 {
  gap: 30px !important;
}

.Checkbox-module__gap-32___VO1aN {
  gap: 32px !important;
}

.Checkbox-module__gap-40___mkKG6 {
  gap: 40px !important;
}

.Checkbox-module__gap-50___XipNi {
  gap: 50px !important;
}

.Checkbox-module__flex-1___t9Z4p {
  flex: 1;
}

.Checkbox-module__flex-none___cXQx9 {
  flex: none !important;
}

.Checkbox-module__flex-column___X9ILs {
  display: flex;
  flex-direction: column !important;
}

.Checkbox-module__flex-row___sL15c {
  display: flex;
  flex-direction: row !important;
}

.Checkbox-module__vertically-centered___UirTU {
  display: flex;
  align-items: center !important;
}

.Checkbox-module__horizontally-centered___H9EYN {
  display: flex;
  justify-content: center !important;
}

.Checkbox-module__horizontally-end___b5mkJ {
  display: flex;
  justify-content: end !important;
}

.Checkbox-module__vertically-start___g1_Hc {
  display: flex;
  align-items: start !important;
}

.Checkbox-module__space-between____bIGA {
  display: flex;
  justify-content: space-between !important;
}

.Checkbox-module__flex-wrap___SCsXe {
  flex-wrap: wrap !important;
}

.Checkbox-module__height-100____XJQJ {
  height: 100%;
}

.Checkbox-module__width-50___mlO4P {
  width: 50% !important;
}

.Checkbox-module__width-100___kUEbc {
  width: 100%;
}

.Checkbox-module__cursor-pointer___KwMAF {
  cursor: pointer;
}

.Checkbox-module__cursor-not-allowed___cDsLj {
  cursor: not-allowed !important;
}

.Checkbox-module__absolute-centered___EmnEo {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Checkbox-module__absolute___LzZfX {
  position: absolute;
}

.Checkbox-module__relative___h09Ey {
  position: relative;
}

.Checkbox-module__fixed___I0_89 {
  position: fixed;
}

.Checkbox-module__visible___gevUd {
  opacity: 1;
}

.Checkbox-module__invisible___CvPNC {
  opacity: 0;
}

.Checkbox-module__col-90___WN0Fg {
  width: 90% !important;
}

.Checkbox-module__col-auto___vO15I {
  width: auto !important;
}

.Checkbox-module__medical-tabs___mcRNp {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Checkbox-module__medical-table-new___eeZ2q {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Checkbox-module__medical-table-new___eeZ2q:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Checkbox-module__medical-table-new___eeZ2q::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Checkbox-module__medical-table-new___eeZ2q::-webkit-scrollbar-track {
  display: none;
}
.Checkbox-module__medical-table-new___eeZ2q.Checkbox-module__no-pagination___FLsag {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Checkbox-module__medical-table-new___eeZ2q.Checkbox-module__no-pagination___FLsag:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Checkbox-module__medical-table-new___eeZ2q.Checkbox-module__no-pagination___FLsag::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Checkbox-module__medical-table-new___eeZ2q.Checkbox-module__no-pagination___FLsag::-webkit-scrollbar-track {
  display: none;
}

.Checkbox-module__medical-table-empty___aHqx8 {
  padding: 14px 40px !important;
}

.Checkbox-module__icon-btn___NsBZU {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Checkbox-module__search-icon___dky61 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Checkbox-module__disable-select___w0LHY {
  user-select: none;
}

.Checkbox-module__break-word___vzCHb {
  word-break: break-word;
}

.Checkbox-module__popup-clear-btn___sVXEi {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Checkbox-module__scroll-m-b-20___Br90O {
  scroll-margin-bottom: 20px;
}

.Checkbox-module__container___jawrL {
  position: relative;
}
.Checkbox-module__container___jawrL.Checkbox-module__disabled___cOil_ {
  opacity: 0.6;
}
.Checkbox-module__container___jawrL .Checkbox-module__input___wwj2c {
  position: absolute;
  visibility: hidden;
}
.Checkbox-module__container___jawrL .Checkbox-module__checkbox___CIciE {
  border: 1px solid #375844;
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  border-radius: 5px;
  margin-right: 15px;
  min-height: 20px;
  min-width: 20px;
  cursor: pointer;
}
.Checkbox-module__container___jawrL .Checkbox-module__checkbox___CIciE.Checkbox-module__disabled___cOil_ {
  cursor: not-allowed;
}
.Checkbox-module__container___jawrL .Checkbox-module__checkbox___CIciE.Checkbox-module__checked___g6gKW {
  box-shadow: 0 0 0 1px #375844;
  background-color: #859989;
}
.Checkbox-module__container___jawrL .Checkbox-module__checkbox___CIciE.Checkbox-module__checked___g6gKW .Checkbox-module__check___xQz3f {
  border-right: 2.2px solid white;
  border-bottom: 2.2px solid white;
  transform: rotate(40deg);
  position: absolute;
  width: 4.8px;
  height: 10px;
  content: "";
  right: 6px;
}
.Checkbox-module__container___jawrL .Checkbox-module__label___ZMZpC {
  color: #375844;
  cursor: pointer;
}
.Checkbox-module__container___jawrL .Checkbox-module__label___ZMZpC.Checkbox-module__disabled___cOil_ {
  cursor: not-allowed;
}

.Checkbox-module__description___rsovT {
  color: #375844;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./../common/src/components/base/Checkbox/Checkbox.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;AA5pBE;EACE,YAAA;AA8pBJ;AA3pBE;EACE,kBAAA;EACA,kBAAA;AA6pBJ;AA1pBE;EACE,yBAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AA4pBJ;AA1pBI;EACE,mBAAA;AA4pBN;AAzpBI;EACE,6BAAA;EACA,yBAAA;AA2pBN;AAzpBM;EACE,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;AA2pBR;AAtpBE;EACE,cAAA;EACA,eAAA;AAwpBJ;AAtpBI;EACE,mBAAA;AAwpBN;;AAnpBA;EACE,cAAA;AAspBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  position: relative;\n\n  &.disabled {\n    opacity: 0.6;\n  }\n\n  .input {\n    position: absolute;\n    visibility: hidden;\n  }\n\n  .checkbox {\n    border: 1px solid get-color(greenNew, dark);\n    box-sizing: border-box;\n    display: inline-block;\n    position: relative;\n    border-radius: 5px;\n    margin-right: 15px;\n    min-height: 20px;\n    min-width: 20px;\n    cursor: pointer;\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n\n    &.checked {\n      box-shadow: 0 0 0 1px get-color(greenNew, dark);\n      background-color: get-color(greenNew, medium);\n\n      .check {\n        border-right: 2.2px solid get-color(white);\n        border-bottom: 2.2px solid get-color(white);\n        transform: rotate(40deg);\n        position: absolute;\n        width: 4.8px;\n        height: 10px;\n        content: '';\n        right: 6px;\n      }\n    }\n  }\n\n  .label {\n    color: get-color(greenNew, dark);\n    cursor: pointer;\n\n    &.disabled {\n      cursor: not-allowed;\n    }\n  }\n}\n\n.description {\n  color: get-color(greenNew, dark);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Checkbox-module__font-s-10___N7UPb`,
	"fontS12": `Checkbox-module__font-s-12___TsP7c`,
	"fontS13": `Checkbox-module__font-s-13___Gt0ri`,
	"fontS14": `Checkbox-module__font-s-14___GAdfa`,
	"fontS15": `Checkbox-module__font-s-15___NTuaN`,
	"fontS16": `Checkbox-module__font-s-16___JcXLP`,
	"fontS18": `Checkbox-module__font-s-18___yFv5r`,
	"fontS20": `Checkbox-module__font-s-20___pSW38`,
	"fontS22": `Checkbox-module__font-s-22___YSdbt`,
	"fontS28": `Checkbox-module__font-s-28___TG50D`,
	"fontW400": `Checkbox-module__font-w-400___L6ktA`,
	"fontW500": `Checkbox-module__font-w-500___wIHf3`,
	"fontW600": `Checkbox-module__font-w-600___pdK_m`,
	"fontW700": `Checkbox-module__font-w-700___qiLvM`,
	"p5": `Checkbox-module__p-5___n7laJ`,
	"p12": `Checkbox-module__p-12___s8JxA`,
	"p16": `Checkbox-module__p-16____puzb`,
	"p30": `Checkbox-module__p-30___PhhaZ`,
	"pB0": `Checkbox-module__p-b-0___gMMrZ`,
	"pB5": `Checkbox-module__p-b-5___rKhEh`,
	"pB10": `Checkbox-module__p-b-10___YClyt`,
	"pB12": `Checkbox-module__p-b-12___x6TT7`,
	"pB16": `Checkbox-module__p-b-16___lZa58`,
	"pB18": `Checkbox-module__p-b-18___JKLhP`,
	"pB20": `Checkbox-module__p-b-20___ZS206`,
	"pB25": `Checkbox-module__p-b-25___LkwTg`,
	"pB30": `Checkbox-module__p-b-30___fHOrH`,
	"pB50": `Checkbox-module__p-b-50____G59p`,
	"pT0": `Checkbox-module__p-t-0___c1HY_`,
	"pT12": `Checkbox-module__p-t-12___SwsHy`,
	"pT16": `Checkbox-module__p-t-16___H7gja`,
	"pT18": `Checkbox-module__p-t-18___zKDLs`,
	"pT20": `Checkbox-module__p-t-20___MOIa0`,
	"pT30": `Checkbox-module__p-t-30___NKsk9`,
	"pT40": `Checkbox-module__p-t-40___Beijw`,
	"pT50": `Checkbox-module__p-t-50___iwtag`,
	"pL20": `Checkbox-module__p-l-20___UrGnF`,
	"pL30": `Checkbox-module__p-l-30___SOLuE`,
	"pL40": `Checkbox-module__p-l-40___bUmiq`,
	"pR16": `Checkbox-module__p-r-16___mSMTT`,
	"pR20": `Checkbox-module__p-r-20___I94_B`,
	"pR30": `Checkbox-module__p-r-30___kA5Ye`,
	"pR50": `Checkbox-module__p-r-50___Y_6Dg`,
	"pR60": `Checkbox-module__p-r-60___zGz9P`,
	"mB1": `Checkbox-module__m-b-1___xiOze`,
	"mB2": `Checkbox-module__m-b-2___xMj0q`,
	"mB6": `Checkbox-module__m-b-6___RTgIn`,
	"mB8": `Checkbox-module__m-b-8___P9ym7`,
	"mB10": `Checkbox-module__m-b-10___mOLap`,
	"mB14": `Checkbox-module__m-b-14___YbQgs`,
	"mB16": `Checkbox-module__m-b-16____oOk0`,
	"mB20": `Checkbox-module__m-b-20___BuAfo`,
	"mB22": `Checkbox-module__m-b-22___c0EaL`,
	"mB24": `Checkbox-module__m-b-24___BXK9b`,
	"mB30": `Checkbox-module__m-b-30___ZTyTp`,
	"mB32": `Checkbox-module__m-b-32___HAeQd`,
	"mB40": `Checkbox-module__m-b-40___CT91L`,
	"mT2": `Checkbox-module__m-t-2___r4Xzc`,
	"mT3": `Checkbox-module__m-t-3___lAvSa`,
	"mT4": `Checkbox-module__m-t-4___vSr_W`,
	"mT5": `Checkbox-module__m-t-5___RUeUx`,
	"mT8": `Checkbox-module__m-t-8___JqYxu`,
	"mT10": `Checkbox-module__m-t-10___VlBma`,
	"mT15": `Checkbox-module__m-t-15___eIkPy`,
	"mT16": `Checkbox-module__m-t-16___nNY1N`,
	"mT20": `Checkbox-module__m-t-20___o_YJi`,
	"mT22": `Checkbox-module__m-t-22___VKbt5`,
	"mT30": `Checkbox-module__m-t-30___IXMKk`,
	"mT32": `Checkbox-module__m-t-32____uVUt`,
	"mLAuto": `Checkbox-module__m-l-auto___fhuVT`,
	"mL4": `Checkbox-module__m-l-4___YP3Qr`,
	"mL5": `Checkbox-module__m-l-5___CJKRV`,
	"mL6": `Checkbox-module__m-l-6___Xs0VW`,
	"mL8": `Checkbox-module__m-l-8___MaF9J`,
	"mL10": `Checkbox-module__m-l-10___Anspo`,
	"mL16": `Checkbox-module__m-l-16___UjMzP`,
	"mL20": `Checkbox-module__m-l-20___Uxj6H`,
	"mL24": `Checkbox-module__m-l-24___A8SEv`,
	"mL30": `Checkbox-module__m-l-30___jWu5z`,
	"mL35": `Checkbox-module__m-l-35___GECep`,
	"mL40": `Checkbox-module__m-l-40___sU2dV`,
	"mR8": `Checkbox-module__m-r-8___Q5dBM`,
	"mR10": `Checkbox-module__m-r-10___l3yVD`,
	"mR16": `Checkbox-module__m-r-16___ScQ_8`,
	"mR20": `Checkbox-module__m-r-20___VWxrl`,
	"mR24": `Checkbox-module__m-r-24___zzBqW`,
	"mR30": `Checkbox-module__m-r-30___WYGUQ`,
	"mR40": `Checkbox-module__m-r-40____iOGv`,
	"borderR3": `Checkbox-module__border-r-3___DyyaK`,
	"borderR4": `Checkbox-module__border-r-4___BKsX1`,
	"borderR6": `Checkbox-module__border-r-6___XnDGv`,
	"borderR10": `Checkbox-module__border-r-10___EWdZu`,
	"borderR12": `Checkbox-module__border-r-12___S6d96`,
	"borderR16": `Checkbox-module__border-r-16___g7Fyf`,
	"borderR50": `Checkbox-module__border-r-50___qiEIy`,
	"primaryBorder": `Checkbox-module__primary-border___nEHg5`,
	"primaryBorderB": `Checkbox-module__primary-border-b___KjfZk`,
	"primaryBorderT": `Checkbox-module__primary-border-t___AD9ZZ`,
	"primaryBorderL": `Checkbox-module__primary-border-l___BM6h0`,
	"primaryBorderR": `Checkbox-module__primary-border-r___w8O1Y`,
	"secondaryBorder": `Checkbox-module__secondary-border___p5y5s`,
	"secondaryBorderB": `Checkbox-module__secondary-border-b___kVDRo`,
	"secondaryBorderT": `Checkbox-module__secondary-border-t___1tX92`,
	"secondaryBorderL": `Checkbox-module__secondary-border-l___CEku5`,
	"secondaryBorderR": `Checkbox-module__secondary-border-r___rFZ6J`,
	"gap0": `Checkbox-module__gap-0___xjkSD`,
	"gap2": `Checkbox-module__gap-2___GyQ23`,
	"gap4": `Checkbox-module__gap-4___iZhzm`,
	"gap5": `Checkbox-module__gap-5___XcEMg`,
	"gap6": `Checkbox-module__gap-6___h7RbL`,
	"gap8": `Checkbox-module__gap-8___V11DZ`,
	"gap10": `Checkbox-module__gap-10___hW3TQ`,
	"gap12": `Checkbox-module__gap-12___pnBmH`,
	"gap14": `Checkbox-module__gap-14___OLd4z`,
	"gap16": `Checkbox-module__gap-16___sAR_R`,
	"gap18": `Checkbox-module__gap-18___JVcKa`,
	"gap20": `Checkbox-module__gap-20___EvEHI`,
	"gap24": `Checkbox-module__gap-24___rR5lP`,
	"gap26": `Checkbox-module__gap-26___xbHRn`,
	"gap30": `Checkbox-module__gap-30___MiUl2`,
	"gap32": `Checkbox-module__gap-32___VO1aN`,
	"gap40": `Checkbox-module__gap-40___mkKG6`,
	"gap50": `Checkbox-module__gap-50___XipNi`,
	"flex1": `Checkbox-module__flex-1___t9Z4p`,
	"flexNone": `Checkbox-module__flex-none___cXQx9`,
	"flexColumn": `Checkbox-module__flex-column___X9ILs`,
	"flexRow": `Checkbox-module__flex-row___sL15c`,
	"verticallyCentered": `Checkbox-module__vertically-centered___UirTU`,
	"horizontallyCentered": `Checkbox-module__horizontally-centered___H9EYN`,
	"horizontallyEnd": `Checkbox-module__horizontally-end___b5mkJ`,
	"verticallyStart": `Checkbox-module__vertically-start___g1_Hc`,
	"spaceBetween": `Checkbox-module__space-between____bIGA`,
	"flexWrap": `Checkbox-module__flex-wrap___SCsXe`,
	"height100": `Checkbox-module__height-100____XJQJ`,
	"width50": `Checkbox-module__width-50___mlO4P`,
	"width100": `Checkbox-module__width-100___kUEbc`,
	"cursorPointer": `Checkbox-module__cursor-pointer___KwMAF`,
	"cursorNotAllowed": `Checkbox-module__cursor-not-allowed___cDsLj`,
	"absoluteCentered": `Checkbox-module__absolute-centered___EmnEo`,
	"absolute": `Checkbox-module__absolute___LzZfX`,
	"relative": `Checkbox-module__relative___h09Ey`,
	"fixed": `Checkbox-module__fixed___I0_89`,
	"visible": `Checkbox-module__visible___gevUd`,
	"invisible": `Checkbox-module__invisible___CvPNC`,
	"col90": `Checkbox-module__col-90___WN0Fg`,
	"colAuto": `Checkbox-module__col-auto___vO15I`,
	"medicalTabs": `Checkbox-module__medical-tabs___mcRNp`,
	"medicalTableNew": `Checkbox-module__medical-table-new___eeZ2q`,
	"noPagination": `Checkbox-module__no-pagination___FLsag`,
	"medicalTableEmpty": `Checkbox-module__medical-table-empty___aHqx8`,
	"iconBtn": `Checkbox-module__icon-btn___NsBZU`,
	"searchIcon": `Checkbox-module__search-icon___dky61`,
	"disableSelect": `Checkbox-module__disable-select___w0LHY`,
	"breakWord": `Checkbox-module__break-word___vzCHb`,
	"popupClearBtn": `Checkbox-module__popup-clear-btn___sVXEi`,
	"scrollMB20": `Checkbox-module__scroll-m-b-20___Br90O`,
	"container": `Checkbox-module__container___jawrL`,
	"disabled": `Checkbox-module__disabled___cOil_`,
	"input": `Checkbox-module__input___wwj2c`,
	"checkbox": `Checkbox-module__checkbox___CIciE`,
	"checked": `Checkbox-module__checked___g6gKW`,
	"check": `Checkbox-module__check___xQz3f`,
	"label": `Checkbox-module__label___ZMZpC`,
	"description": `Checkbox-module__description___rsovT`
};
module.exports = ___CSS_LOADER_EXPORT___;
